
import servise from '@/router/axios'

export const setStatus = (data) => {
  return servise({
    url: '/reportCollect/update/modify/display',
    method: 'PUT',
    data
  })
}

export const auditing = (data) => {
  return servise({
    url: '/reportCollect/modify/reconciliation',
    method: 'PUT',
    data
  })
}

export const setRemark = (data) => {
  return servise({
    url: '/reportCollect/modify/remark',
    method: 'PUT',
    data
  })
}